module.exports = __webpack_public_path__ + "static/img/bg-1.7e68612e.png";